import { client } from "./client";
import { hybrid } from "./hybrid";

import { getQueryVariable } from "../utils/getQueryVariable";

const getItem = (key: string) => {
  return JSON.parse(localStorage.getItem(key)!);
};

export async function saveRegistrationData(setRegistrationData: (data: any) => void) {
  const publicId = getQueryVariable("r");

  const patient = getItem(`patient_${publicId}`);

  const { data } = await client.post(
    `/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
    {
      parameters: {
        public_id: publicId,
        patient: {
          ...patient,
          custom_sexint_save: Number(patient.custom_sexint_save),
        },
        allergies: getItem(`allergens_${publicId}`) || [],
        dietanamnez: getItem(`dietanamnez_${publicId}`),
        dietanamnezItems: getItem(`dietanamnezItems_${publicId}`) || [],
        self_registration_id: localStorage.getItem('self_registration_id') ? localStorage.getItem('self_registration_id') : localStorage.getItem(`self_registration_id_${publicId}`)
      },
    },
    {
      headers: {
        Function: "SelfRegistration",
      },
    }
  );

  if (window.location.pathname === "/pl" || window.location.pathname === "/lp") {
    const { data } = await hybrid.post(
      `/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
      {
        parameters: {
          public_id: publicId,
          patient: {
            ...patient,
            custom_sexint_save: Number(patient.custom_sexint_save),
          },
          allergies: getItem(`allergens_${publicId}`) || [],
          dietanamnez: getItem(`dietanamnez_${publicId}`),
          dietanamnezItems: getItem(`dietanamnezItems_${publicId}`) || [],
          self_registration_id: localStorage.getItem('self_registration_id') ? localStorage.getItem('self_registration_id') : localStorage.getItem(`self_registration_id_${publicId}`)
        },
      },
      {
        headers: {
          Function: "SelfRegistration",
        },
      }
    );

    setRegistrationData(data)
    localStorage.removeItem('self_registration_id')
    localStorage.removeItem(`self_registration_id_${publicId}`);
    return data;
  }
  setRegistrationData(data)
  localStorage.removeItem('self_registration_id')
  localStorage.removeItem(`self_registration_id_${publicId}`);

  return data;
}
